import { GET_TEMPLATE_BY_ID, GET_TEMPLATES_LIST, UPDATE_TEMPLATE_STEP_BY_ID, GET_CAMPAIGNS_FOR_TEMPLATE_APPLY, APPLY_TEMPLATE_TO_CAMPAIGN } from "../constants";
import Requests from "../requests";

const TemplatesService = {
    getTemplates,
    getTemplateById,
    updateTemplateStep,
    getCampaignsForTemplateApply,
    applyTemplateToCampaign
}

async function getTemplates() {
    return Requests.getWithAuth(GET_TEMPLATES_LIST);
}

async function getTemplateById(_id) {
    return Requests.getWithAuth(GET_TEMPLATE_BY_ID(_id));
}

async function updateTemplateStep(step_id, step) {
    return Requests.postWithAuth(UPDATE_TEMPLATE_STEP_BY_ID(step_id), step);
}

async function getCampaignsForTemplateApply(templateId) {
    return Requests.getWithAuth(GET_CAMPAIGNS_FOR_TEMPLATE_APPLY(templateId));
}

async function applyTemplateToCampaign(templateId, sequenceId) {
    return Requests.postWithAuth(APPLY_TEMPLATE_TO_CAMPAIGN, {
        template_id: templateId,
        sequence_id: sequenceId
    });
}

export default TemplatesService;